import { render, staticRenderFns } from "./BeLeftSidebar.vue?vue&type=template&id=1efb17ac&"
import script from "./BeLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./BeLeftSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports